import { render, staticRenderFns } from "./AddUpdateFoodCategory.vue?vue&type=template&id=78ec59b6&scoped=true"
import script from "./AddUpdateFoodCategory.vue?vue&type=script&lang=js"
export * from "./AddUpdateFoodCategory.vue?vue&type=script&lang=js"
import style0 from "./AddUpdateFoodCategory.vue?vue&type=style&index=0&id=78ec59b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ec59b6",
  null
  
)

export default component.exports